// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import UsersList from './UsersList';

export default compose(
  connect(
    state => ({
      app: state.app
    }),
    dispatch => ({}),
  ),
)(UsersList);
